export default {"src":"/_next/static/media/instagram-icon.eec0955a.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};